module.exports = __webpack_public_path__ + "media/images/character/zen_chan_jump_r-56e53278188affcb276462b510e3d4a2.png";